import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SavePopupResponseInput } from '@/models/caller';

export const saveShoppingPopupResponse = async ({ phoneNumber, clientResponse, notInterestedReason }: SavePopupResponseInput) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      clientResponse,
      notInterestedReason,
    },
    mutation: graphql(`
      mutation SaveShoppingPopupResponse($phoneNumber: String!, $clientResponse: String!, $notInterestedReason: String) {
        saveShoppingPopupResponse(phoneNumber: $phoneNumber, clientResponse: $clientResponse, notInterestedReason: $notInterestedReason) {
          id
          shoppingPopup {
            callSid
            clientResponse
            notInterestedReason
          }
        }
      }
    `),
  });

  return response.data?.saveShoppingPopupResponse;
};
